module.exports = __webpack_public_path__ + "img/rain_blue.717c6d9d.gif";